import { Component, OnInit, Inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { ChangeDisclaimerAction } from "../disclaimers.actions";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-disclaimer-edit",
  templateUrl: "./disclaimer-edit.component.html",
  styleUrls: ["./disclaimer-edit.component.scss"],
  standalone: false,
})
export class DisclaimerEditComponent implements OnInit {
  form: UntypedFormGroup;
  saving = false;
  editMode = true;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<DisclaimerEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      disclaimer?: { addonId: string; name: string; htmlContent: string };
    },
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    const disclaimerData = this.data?.disclaimer || {
      addonId: "",
      name: "",
      htmlContent: "",
    };
    this.form = new UntypedFormGroup({
      addonId: new UntypedFormControl(disclaimerData.addonId, (c) =>
        Validators.required(c),
      ),
      name: new UntypedFormControl(disclaimerData.name || "", (c) =>
        Validators.required(c),
      ),
      htmlContent: new UntypedFormControl(
        disclaimerData.htmlContent || "",
        (c) => Validators.required(c),
      ),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid) {
      return;
    }
    this.saving = true;
    const formValue = this.form.value as {
      addonId: string;
      name: string;
      htmlContent: string;
    };
    this.store.dispatch(new ChangeDisclaimerAction(formValue));
    this.dialogRef.close(true);
  };

  cancel = () => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
